<script lang="ts">
	import CreditCardIcon from "@lucide/svelte/icons/credit-card";
	import SettingsIcon from "@lucide/svelte/icons/settings";
	import UserPlusIcon from "@lucide/svelte/icons/user-plus";
</script>

<section id="online-portal" class="relative bg-neutral-900 py-16">
	<!-- Background image with full coverage -->
	<div class="absolute inset-0 z-0 overflow-hidden opacity-50">
		<!-- 		<img
			src=""
			alt="Online Portal"
			class="absolute left-1/2 top-1/2 h-[300%] w-[300%] -translate-x-1/2 -translate-y-1/2 transform object-cover blur-md"
		/> -->
	</div>

	<!-- Content overlay with semi-transparent background for better readability -->
	<div class="relative z-10 container mx-auto px-4">
		<div class="p-8">
			<h2 class="mb-6 text-center text-4xl font-medium text-white">YOUR ONLINE PORTAL</h2>
			<hr class="border-primary mx-auto mb-8 w-[100px] border-2" />

			<div class="grid grid-cols-1 gap-8 md:grid-cols-3">
				<div class="text-center">
					<div
						class="bg-primary mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full"
					>
						<CreditCardIcon class="h-8 w-8 text-white" />
					</div>
					<h3 class="mb-4 text-xl font-medium text-white">PAY RENT ONLINE</h3>
					<p class="text-lg text-white">
						Securely pay rent online from anywhere. Set up automatic payments so you pay
						on time.
					</p>
				</div>

				<div class="text-center">
					<div
						class="bg-primary mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full"
					>
						<SettingsIcon class="h-8 w-8 text-white" />
					</div>
					<h3 class="mb-4 text-xl font-medium text-white">MAINTENANCE REQUESTS</h3>
					<p class="text-lg text-white">
						Quickly submit maintenance requests that go directly to our maintenance
						queue.
					</p>
				</div>

				<div class="text-center">
					<div
						class="bg-primary mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full"
					>
						<UserPlusIcon class="h-8 w-8 text-white" />
					</div>
					<h3 class="mb-4 text-xl font-medium text-white">SIGN UP</h3>
					<p class="text-lg text-white">
						Sign up today to pay rent, submit maintenance requests, and view your online
						account from anywhere.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>
